import React from 'react';
import { motion } from 'framer-motion';
import Card from './Card';
import { Search } from 'lucide-react';

const EmptyState = () => (
  <motion.div 
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    className="col-span-full py-20 flex flex-col items-center justify-center text-center"
  >
    <div className="h-16 w-16 bg-white/5 rounded-full flex items-center justify-center mb-6">
      <Search className="w-8 h-8 text-gray-500" />
    </div>
    <h3 className="text-xl font-semibold text-white mb-2">No spots found</h3>
    <p className="text-gray-400 max-w-sm mx-auto">
      Try adjusting your filters to find what you're looking for.
    </p>
  </motion.div>
);

const LoadingSkeleton = () => (
  <div className="space-y-4">
    <div className="aspect-[4/3] bg-white/5 rounded-2xl animate-pulse" />
    <div className="space-y-2">
      <div className="h-4 bg-white/5 rounded w-3/4 animate-pulse" />
      <div className="h-3 bg-white/5 rounded w-1/2 animate-pulse" />
    </div>
  </div>
);

const SpotGrid = ({ spots, loading }) => (
  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-10">
    {loading ? (
      [...Array(6)].map((_, i) => <LoadingSkeleton key={i} />)
    ) : spots.length > 0 ? (
      spots.map((spot, index) => (
        <motion.div
          key={spot.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.05 }}
        >
          <Card spot={spot} />
        </motion.div>
      ))
    ) : (
      <EmptyState />
    )}
  </div>
);

export default SpotGrid;